<template>
    <button class="btn btn-success" @click="modal = !modal">crear plato +</button>
    <div v-if="modal" class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Crear</h5>
                <button @click="modal = !modal" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div id='example-3' class="d-flex flex-wrap">
                    <div v-for="alergeno in v_allergens_es" :key="alergeno.id" class="mx-1">
                        <input type="checkbox" :id="alergeno.id" :value="alergeno.id" v-model="plat.allergens">
                        
                        <label :for="alergeno.id">
                        <img 
                            v-on:click="toggle_btn_allergen"
                            class="img-icon" 
                            :src="require('../../../assets/icon/' + alergeno.icon_name + '.svg')" 
                            :alt="alergeno.name" aria-hidden="true" data-toggle="tooltip"  width="25"
                            :title="alergeno.name">
                            {{alergeno.name}}
                        </label>
                    </div>
                </div>

                <div class="form-floating mb-3">
                    <input v-model="plat.name" type="email" class="form-control">
                    <label>Nombre del plato</label>
                </div>
                <div class="form-floating mb-3">
                    <textarea style="height:185px;" v-model="plat.description" type="text" class="form-control"></textarea>
                    <label>Descripcion</label>
                </div>
                <div class="row">
                    <div class="col-6">
                        <div class="form-floating mb-3">
                            <input v-model="plat.price" type="number" class="form-control">
                            <label>Precio principal</label>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-floating mb-3">
                            <input v-model="plat.price_tinta" type="number" class="form-control">
                            <label>Precio Copa/Media pinta</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <photo-component :url="v_url_photo" :photolaravel="plat.photo"></photo-component>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <input type="radio" id="uno" value="es" v-model="plat.lang" class="mx-2">
                                <label for="uno">ES</label>
                                <br>
                                <input type="radio" id="Dos" value="en" v-model="plat.lang" class="mx-2">
                                <label for="Dos">EN</label>
                            </div>
                            <div class="col">
                                <label for="">Habilitado:</label>
                                <span class="form-switch">
                                    <input 
                                    class="form-check-input"
                                    type="checkbox"
                                    true-value="1"
                                    false-value="0"
                                    v-model="plat.enabled" 
                                    >
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label>categoria:</label>
                        <v-select 
                            class="bg-light"
                            v-model="plat.category_id" 
                            label="title" 
                            :reduce="category => category.id" 
                            :options="v_categories"
                        ></v-select>
                    </div>
                    <div class="col">
                        <div class="row">
                            <div class="col">
                                <div class="form-floating mb-3">
                                    <input v-model="plat.ABV" type="number" class="form-control">
                                    <label>ABV</label>
                                </div>          
                            </div>
                            <div class="col">
                                <div class="form-floating mb-3">
                                    <input v-model="plat.IBU" type="number" class="form-control">
                                    <label>IBU</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-floating mb-3">
                    <input v-model="plat.subgroup" type="text" class="form-control">
                    <label>Subgrupo</label> 
                </div>
                <div class="form-floating mb-3">
                    <input v-model="plat.subgroup_description" type="text" class="form-control">
                    <label>Subgrupo Descripcion</label>
                </div>
            </div>
            <div class="modal-footer">
                <button @click="modal = !modal" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button @click="create_plate" type="button" class="btn btn-primary">Guardar cambios</button>
            </div>
            </div>
        </div>
    </div>

</template>
<script>
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import {ref,computed, onMounted} from 'vue';

import axios from 'axios';

import photoComponent from '../photos/photoComponent.vue';
import vSelect from 'vue-select'

import 'vue-select/dist/vue-select.css';


export default{
props:['category'],
emits:['check'],
components:{
    'v-select':vSelect,
    'photo-component':photoComponent,
},
setup(props ,{emit}){
    const store = useStore()
    const toast = useToast()

    const v_allergens_es = computed(()=>store.state.v_allergens_es)
    const v_user = computed(()=>store.state.login.v_user)
    const v_photo = computed(()=>store.state.v_photo)
    
    
    const modal = ref(false)
    const plat = ref({
        name:'',
        description:'',
        price:null,
        price_tinta:null,
        lang:'es',
        food:'all',
        enabled:1,
        photo:null,
        ABV:null,
        IBU:null,
        brewery:'',
        category_id:props.category,
        subgroup:null,
        subgroup_description:null,
        position:null,
        allergens:[],

    })
    
   

    const create_plate = () =>{

        let config = {
            headers: {
            'Authorization': 'Bearer ' + v_user.value.accessToken,
            'Accept':'application/json'
            }
        }

        console.log('here create plate')
         axios.post(store.state.v_url_global+'/plates',{
                name:plat.value.name,
                description:plat.value.description,
                price:plat.value.price,
                price_tinta:plat.value.price_tinta,
                lang:plat.value.lang,
                food:plat.value.food,
                enabled:parseInt(plat.value.enabled),
                photo:v_photo.value,
                ABV:plat.value.ABV,
                IBU:plat.value.IBU,
                brewery:plat.value.brewery,
                category_id:plat.value.category_id,
                allergens:JSON.stringify(plat.value.allergens),//plat.allergens //plat.value.allergens_ids
                subgroup:plat.value.subgroup,
                subgroup_description:plat.value.subgroup_description,
                position:plat.value.position,
            },config).then(function (response) {
                store.dispatch('v_action_categories').then(()=>{
                    emit('check',props.category);
                    console.log('actualizado');
                    })
                toast.success(response.data);
                modal.value = !modal.value;
            })
            .catch(function (error) {
                toast.error(error);
            });
        
    }


    onMounted(()=>{
        console.log('hola  create'+props.category)

    })

    return{
        modal,
        plat,
        v_allergens_es,
        v_user,
        v_photo,
        create_plate,
        v_categories:computed(()=>store.state.v_categories),
        v_url_photo:computed(()=>store.state.v_url_photo),
    }
}
}
</script>